import { memo } from "react";
import { Icons, type IconsProps } from "../components/celebration/Icons";
import styles from "./LateIcon.module.scss";

export interface LateIconProps {
  size?: IconsProps["size"];
}

const LateIcon: React.FC<LateIconProps> = ({ size = "lg" }) => {
  return (
    <div className={`${styles.late} ${styles[size]}`}>
      <Icons icon="spam" size={size} />
    </div>
  );
};

export default memo(LateIcon);
